import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Teachr from '../../../../Objects/models/Teachr';
import { useDispatch, useSelector } from 'react-redux';
import { PDFDocument, rgb } from 'pdf-lib';
import { Address } from '../../../../Objects/models/Address';
import AddressRepository from '../../../../Repositories/AddressRepository';
import SignaturePad from "react-signature-canvas";
import moment from 'moment';
import ImageRepository from '../../../../Repositories/ImageRepository';
import TeachrRepository from '../../../../Repositories/TeachrRepository';
const Sixth = (props: any) => {
    let padRef = useRef<SignaturePad>(null);
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false)
    const [show, setShow] = useState(true)
    const [dataURL, setDataURL] = useState<string | null>(null);
    const [isSign, setIsSign] = useState(false)
    const [teachr, setTeachr] = useState<Teachr>()
    const [address, setAddress] = useState<Address>()
    const generalTeachr = useSelector((state: any) => state.teachr)
    const [pdfFile, setPdfFile] = useState(process.env.PUBLIC_URL + "/Conditions_de_services_VDEF.pdf");
    const [pdfBlob, setPdfBlob] = useState<Blob>();
    const clear = () => {
        if (padRef) {
            padRef.current?.clear()
        }
        setDataURL(null)
        setShow(true)
    };
    const trim = () => {
        const url = padRef.current?.getTrimmedCanvas().toDataURL("image/png");
        if (url) {
            setDataURL(url)
        };
    };
    const validateSign = () => {
        trim()
        if (dataURL) {
            setOpen(false)
            setIsSign(true)
        }
    }
    async function displayModifiedPdf() {
        const pdfUrl = pdfFile
        const pdfBytes = await fetch(pdfUrl).then((res) => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(pdfBytes);

        const form = pdfDoc.getForm();
        const nameField = form.getTextField('name');
        const siretField = form.getTextField('siret');
        const addressField = form.getTextField('address');
        const cityField = form.getTextField('city');
        const dateField = form.getTextField('date');
        dateField.setText(moment().format("L"))
        if (teachr) {
            nameField.setText(teachr.firstName + ' ' + teachr.lastName);
            siretField.setText(teachr.RCS);
        }
        if (address) {
            addressField.setText(address.formattedAddress);
            cityField.setText(address.city)
        }

        if (isSign && dataURL) {
            const pages = pdfDoc.getPages();
            let currentPage = pages[8];
            const imageBytes1 = await fetch(dataURL).then((res) =>
                res.arrayBuffer()
            );
            const image1 = await pdfDoc.embedPng(imageBytes1);
            let imageWidth = 100;
            let imageHeight = 30;
            currentPage.drawImage(image1, {
                x: currentPage.getWidth() / 2 + imageWidth / 2,
                y: imageWidth * 2 + 20,
                width: imageWidth,
                height: imageHeight,
            });
            currentPage = pages[9]
            currentPage.drawImage(image1, {
                x: 80,
                y: imageWidth * 3,
                width: imageWidth,
                height: imageHeight,
            });
            setIsSign(true);
        }
        const modifiedPdfBytes = await pdfDoc.save();
        const modifiedPdfBlob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });
        const modifiedPdfUrl = URL.createObjectURL(modifiedPdfBlob);
        setPdfFile(modifiedPdfUrl)
        setPdfBlob(modifiedPdfBlob)

    }
    useEffect(() => {
        displayModifiedPdf();
    }, [teachr, address, isSign]);
    useEffect(() => {
        if (generalTeachr.teachr) {
            setTeachr(generalTeachr.teachr)
            if (generalTeachr.teachr.address) {
                const addressId = parseInt(generalTeachr.teachr.address.match(/\d+/)[0])
                AddressRepository.fetchAddressById(addressId).then((response) => {
                    setAddress(response)
                })
            }

        }
    }, [generalTeachr])
    const openSignScreen = () => {
        if (!isSign) {
            setOpen(true)
        }
    }
    const handleClick = () => {
        if (isSign && teachr && pdfBlob) {
            setLoading(true)
            ImageRepository.createImage(new File([pdfBlob], 'proof-is-sign-mandat', { type: 'application/pdf' })).then((response) => {
                teachr.proofMandat = response['@id']
                if (teachr.proofIdentity) {
                    teachr.proofIdentity = teachr.proofIdentity['@id']
                }
                if (teachr.proofIdentity2) {
                    teachr.proofIdentity2 = teachr.proofIdentity2['@id']
                }
                if (teachr.proofSignSap) {
                    teachr.proofSignSap = teachr.proofSignSap['@id']
                    teachr.signSap = true
                }
                if (teachr.proofIsAE) {
                    teachr.proofIsAE = teachr.proofIsAE['@id']
                }
                TeachrRepository.updateTeachr(teachr).then((teachrResponse) => {
                    dispatch({
                        type: 'SET_TEACHR_INFO',
                        payload: {
                            teachr: teachrResponse
                        }
                    })
                    props.nextStep(6)
                    setLoading(false)
                })
            }).catch((error) => {
                setLoading(false)
            })
        }
    }
    return (
        <div className='flex flex-col lg:border border-[rgba(146,211,255,0.54)] lg:shadow-profile-complete-select rounded-lg lg:p-8 p-4 gap-y-4'>
            <h4 className='text-lg font-extrabold lg:text-[22px] text-first'>Prenez connaissance des conditions de services et veuillez les accepter </h4>
            <div className="flex flex-col gap-y-8">
                <embed src={pdfFile} id="pdfEmbed" type="application/pdf" width="100%" height="500" />
                <div className='flex items-center gap-2 py-4' onClick={openSignScreen}>
                    <Checkbox checked={isSign} className='p-0' />
                    <div className='text-normal font-bold lg:text-xl text-xs'>
                        <label className='underline cursor-pointer'>Accepter les conditions de service de Teach’r</label>
                    </div>
                </div>
            </div>
            <div className="flex justify-between lg:pt-8 flex-col lg:flex-row gap-y-4">
                <Button onClick={() => props.nextStep(4)} className='text-[#B7B7B7] lg:text-lg text-sm font-extrabold rounded-full py-2 px-8 disabled:opacity-30 order-last lg:order-first w-full lg:w-max' disabled={loading}>PRÉCÉDENT</Button>
                <Button onClick={handleClick} className='text-white bg-radio font-extrabold rounded-full py-2 px-8 disabled:opacity-30 w-full lg:w-max' disabled={loading ? true : !isSign}>SUIVANT </Button>

            </div>
            <Dialog
                fullWidth

                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className='rounded-[42px]'
                sx={{
                    "& .MuiPaper-root": {
                        borderRadius: {
                            "xs": "12px",
                            "lg": "42px"
                        },
                        position: "relative",
                        boxShadow: "4px 10px 20px 0px rgba(0,0,0,0.25)",
                        width: {
                            "xs": "92%",
                            "lg": "calc(100% - 64px)",
                        },
                        margin: {
                            "xs": "0px",
                            "lg": "32px",
                        },
                        maxHeight: "100%"
                    }
                }}
            >
                <div className="flex flex-col  md:p-4 gap-y-4">
                    <DialogTitle id="alert-dialog-title" >
                        <h2 className='mt-4 lg:mt-10 font-extrabold  uppercase text-first lg:text-2xl text-center text-base'> Appliquer cette signature</h2>
                    </DialogTitle>
                    <DialogContent className='flex flex-col gap-y-8 lg:py-10'>
                        <div className="">
                            <p className='lg:text-xl font-bold text-normal text-sm'>Veuillez signez les conditions de services en appliquant votre signature ci-dessous. </p>
                            <div className='w-auto xl:max-w-lg 2xl:max-w-none bg-white rounded-[9px] border-[#D2D2D2] border p-4 flex-col flex gap-y-8 my-8 relative'>
                                {show &&
                                    <div className='absolute left-0 w-full top-[50%]'>
                                        <div className=' w-5/6 mx-auto  border-[#D2D2D2]'>
                                            <p className='text-[#D2D2D2] font-bold text-base lg:text-xl text-center cursor-default select-none'>Signer ici</p>
                                        </div>
                                    </div>
                                }
                                <div className="flex items-center justify-between ">
                                    <div className='flex items-center gap-x-4'>
                                        <Button className='cursor-pointer bg-[#E8F5FF] border-first border-solid border' title='dessiner'>
                                            <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.2424 3.03668H13.6618C13.2023 3.03668 12.798 3.31237 12.6325 3.71672C12.3201 3.51454 11.9525 3.29399 11.5482 3.05506C11.3644 2.94479 11.1622 2.83451 10.96 2.76099L11.1438 2.5772C11.6952 2.02582 11.6952 1.12524 11.1438 0.555479L11.0519 0.463583C10.5006 -0.0877958 9.59997 -0.0877958 9.03021 0.463583L7.02687 2.46692C5.39111 2.52206 3.60832 3.34913 2.90991 3.71672C2.70773 3.82699 2.50556 3.97403 2.35853 4.13944C0.943324 5.6833 0.373566 6.87795 0.336807 6.91471L0.300049 7.00661V7.0985C0.355187 7.7234 0.686014 8.1645 1.25577 8.34829L0.557359 10.5722C0.5206 10.7008 0.557359 10.8479 0.649255 10.9398C0.722772 11.0133 0.814669 11.05 0.906565 11.05C0.943324 11.05 0.980082 11.05 1.01684 11.0317L3.31425 10.3333C3.36939 10.3149 3.42453 10.2781 3.46129 10.2414L4.0678 9.63484C4.26997 9.72674 4.47215 9.7635 4.6927 9.7635H6.76956C7.52311 9.80026 8.40531 9.81864 9.25076 9.81864C10.9233 9.81864 12.4488 9.7635 12.4488 9.7635H12.6877C12.8899 10.0943 13.2391 10.3149 13.6618 10.3149H15.224C15.8489 10.3149 16.3452 9.81864 16.3452 9.19374V4.15782C16.3635 3.53292 15.8489 3.03668 15.2424 3.03668ZM1.0536 7.15364C1.20063 6.85957 1.77039 5.86709 2.89153 4.63568C2.98342 4.5254 3.11208 4.43351 3.24073 4.37837C3.77373 4.10268 4.96839 3.53292 6.1998 3.31237L1.78877 7.7234C1.20063 7.68664 1.07198 7.35581 1.0536 7.15364ZM3.02018 9.65322L1.47632 10.1311L1.95418 8.58723L7.41283 3.12858L7.43121 3.1102L9.54483 0.996582C9.82052 0.720893 10.2432 0.720893 10.5189 0.996582L10.6108 1.08848C10.8865 1.36417 10.8865 1.78689 10.6108 2.06258L5.55652 7.11688H4.63756C4.10456 7.11688 3.6267 7.39257 3.38777 7.85205C3.20398 8.20126 3.20398 8.58723 3.36939 8.95481C3.40615 9.02833 3.44291 9.10184 3.49804 9.17536L3.02018 9.65322ZM7.41283 6.7493C7.33931 6.95147 7.082 7.08012 6.71442 7.11688H6.58576L7.37607 6.32657C7.44959 6.49199 7.46797 6.63902 7.41283 6.7493ZM12.4488 9.02833C12.412 9.02833 9.01183 9.1386 6.78794 9.02833H4.6927C4.52728 9.02833 4.36187 8.97319 4.23322 8.88129C4.14132 8.80778 4.08618 8.73426 4.03104 8.64236C3.95753 8.47695 3.95753 8.32992 4.03104 8.18288C4.14132 7.98071 4.36187 7.85205 4.63756 7.85205H6.7328H6.82469L6.84307 7.83367C7.46797 7.76016 7.92745 7.46609 8.09286 7.00661C8.2399 6.62064 8.18476 6.17954 7.92745 5.7752L10.3719 3.34913C10.6476 3.42265 10.9233 3.5513 11.1806 3.69834C11.7136 4.01078 12.1547 4.28647 12.559 4.54378V9.04671L12.4488 9.02833ZM15.6284 9.19374C15.6284 9.41429 15.4446 9.57971 15.2424 9.57971H13.6618C13.4412 9.57971 13.2758 9.39591 13.2758 9.19374V4.15782C13.2758 3.93727 13.4596 3.77185 13.6618 3.77185H15.224C15.4446 3.77185 15.61 3.95565 15.61 4.15782V9.19374H15.6284Z" fill="#0054A3" />
                                            </svg>

                                        </Button>
                                    </div>
                                    <div className="cursor-pointer">
                                        <span onClick={clear} className='text-sm font-semibold text-normal'>Effacer</span>
                                    </div>
                                </div>
                                <SignaturePad onEnd={trim} velocityFilterWeight={0.2} onBegin={() => setShow(false)} maxWidth={1} minWidth={1} ref={padRef} canvasProps={{ className: "sigCanvas border-2 border-dotted z-50" }} />

                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions className='flex-col lg:flex-row gap-y-4'>
                        <Button onClick={() => setOpen(false)} className='block  py-2  mx-auto font-extrabold lg:text-white rounded-full lg:bg-third order-last lg:order-first w-full lg:w-1/3 text-third'>Refuser</Button>
                        <Button onClick={validateSign} className='block  py-2  mx-auto font-extrabold text-white rounded-full bg-first disabled:opacity-30  w-full lg:w-1/3' disabled={dataURL ? false : true}>Valider</Button>
                    </DialogActions>
                </div>
            </Dialog>
        </div>
    );
};

export default Sixth;